import Image from 'next/image'
import { useLanguage } from '@/contexts/LanguageContext'

export default function NeighbourhoodFave() {
  const { language } = useLanguage()
  const awardTranslations = {
    en: {
      voted: 'Voted',
      fave: 'Neighbourhood Fave 2023',
      for: 'for Best Home & Garden!'
    },
    cy: {
      voted: 'Enillodd',
      fave: 'Ffefryn y Gymdogaeth 2023',
      for: 'am Gartref a Gardd Orau!'
    }
  }
  const t = awardTranslations[language]
  return (
    <section className="py-10 flex justify-center bg-white">
      <div className="flex flex-col items-center gap-3 px-4">
        <Image
          src="/images/awards/award-2023.webp"
          alt={language === 'en' ? 'Neighbourhood Fave 2023 Award Badge' : 'Bathodyn Gwobr Ffefryn y Gymdogaeth 2023'}
          width={316}
          height={316}
          className="bg-white"
          priority
        />
        <div className="text-center">
          <span className="text-lg md:text-xl font-semibold text-gray-900 text-center">
            {t.voted} <span className="text-gray-700">{t.fave}</span> {t.for}
          </span>
        </div>
      </div>
    </section>
  )
} 